"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pandeConditionReducer = exports.pandeConditionActions = exports.TYPES_CONDITION = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _objectUtil = _interopRequireDefault(require("01_core/logics/objectUtil"));
var _coreConditionActions = require("01_core/reducers/coreConditionActions");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Condition';

// アクションタイプ
const TYPES_CONDITION = exports.TYPES_CONDITION = {
  SAVE: PREFIX + 'Save'
};

// 初期状態
const INIT_STATE = {
  reportNo: '',
  kaishaCd: '',
  soshikiCd: '',
  kaishaSoshikiLabel: '',
  initKaishaSoshikiComplete: false,
  workPlaceEntry: {},
  reportEndFlg: _CodeConsts.CODE.PANDE_REPORT_END_FLG.CODE_0,
  reportStatusCd: [],
  kensaRstCd: [],
  firstReportDtStart: '',
  firstReportDtEnd: '',
  kensaRstDtStart: '',
  kensaRstDtEnd: ''
};
const pandeConditionActions = exports.pandeConditionActions = (0, _reduxActions.createActions)({
  [TYPES_CONDITION.SAVE]: function () {
    return {
      conditions: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, _coreConditionActions.TYPES_CORE_CONDITION.CLEAR);
const pandeConditionReducer = exports.pandeConditionReducer = (0, _reduxActions.handleActions)({
  [TYPES_CONDITION.SAVE]: (state, action) => _objectSpread(_objectSpread({}, state), _objectUtil.default.cloneMatchedKey(action.payload.conditions, Object.keys(state))),
  [_coreConditionActions.TYPES_CORE_CONDITION.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);